<template>
  <div class="hello">
    <!--h1>{{ msg }}</h1-->
    <b-card>
      <b-media right-align>
        <b-media-body class="ml-2" align="left">
          <h4 class="mt-0"> 제품 리스트 </h4>
          <p>
            <b>㈜한흥실업</b> 생산 목록
          </p>
        </b-media-body>
      </b-media>
      <div v-for="bar in bars" v-bind:key="bar.key" class="row mb-1">
        <div class="col-sm-2">{{ bar.key }}:</div>
        <div class="col-sm-10 pt-1">
          <b-progress :value="bar.value" :variant="bar.variant" :key="bar.key"></b-progress>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'Product',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      bars: [
        { key: '그리트', variant: 'success', value: 25 },
        { key: '대분', variant: 'info', value: 80 },
        { key: '5호사', variant: 'warning', value: 40 },
        { key: '6호사', variant: 'danger', value: 55 },
        { key: '20#', variant: 'primary', value: 30 },
        { key: '50#', variant: 'secondary', value: 40 },
        { key: '100# ~', variant: 'dark', value: 20 }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/Product.vue